import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import DiasorteLogo from '../../asserts/images/diasorteLogo.png';
import { useNavigate } from 'react-router-dom';
const dataList: any = [
	{
		name: 'Diasorte',
		url: 'https://www.dia-sorte.mourgames.com',
		img: DiasorteLogo,
	},
	{
		name: '7BOSLOT',
		url: 'https://main.7bslot.mourgames.com',
		img: '',
	},
	{
		name: 'BOOMA777',
		url: 'https://booma777.7bslot.mourgames.com',
		img: '',
	},
];
export const Home = () => {
	const [query, setQuery] = useState('');
	const navigate = useNavigate();
	const filteredData =
		dataList.length > 0 && query.trim() !== ''
			? dataList.filter(
					(item: any) =>
						query
							.toLowerCase()
							.split('') // 将 query 拆成单个字符
							.some((char) => item?.name?.toLowerCase().includes(char)) // 只要匹配一个字母就返回
			  )
			: dataList;
	return (
		<div className="home">
			{/* <div className="header">
				<div className="logo"></div>
			</div> */}
			<div className="search">
				<Input
					className="input"
					value={query}
					onChange={(e) => setQuery(e.target.value)}
					prefix={<SearchOutlined />}
				></Input>
			</div>
			<div className="allGamnes">All Ganmes</div>
			<div className="main">
				{filteredData.map((item: any, index: any) => (
					<div className={`item`} key={index}>
						<div
							className={`content ${item?.name === '7BOSLOT' ? 'BOSLOT' : item?.name}`}
							onClick={() => {
								window.open(item?.url);
							}}
						>
							<div className="merchantLogo">
								<img src={item?.img} alt="" />
							</div>
						</div>
						<div
							className="name"
							onClick={() => {
								window.open(item?.url);
							}}
						>
							{item?.name}
						</div>
					</div>
				))}
			</div>
			<div className="homeFooter">
				<div className="rule">
					<div className="ruleTitle">Regras</div>
					<div className="ruleContent">
						<div
							className="menuList"
							onClick={() => {
								navigate('/general_terms_and_conditions');
							}}
						>
							Termos e Condições Gerais
						</div>
						<div
							className="menuList"
							onClick={() => {
								navigate('/responsible_gaming');
							}}
						>
							Jogo responsável
						</div>
						<div
							className="menuList"
							onClick={() => {
								navigate('/sports_betting_rules');
							}}
						>
							Regras de apostas esportivas
						</div>
						<div
							className="menuList"
							onClick={() => {
								navigate('/general_bonus_terms_and_conditions');
							}}
						>
							Termos e condições gerais de bônus
						</div>
						<div
							className="menuList"
							onClick={() => {
								navigate('/privacy_policy');
							}}
						>
							Política de privacidade
						</div>
						<div
							className="menuList"
							onClick={() => {
								navigate('/payment_rules');
							}}
						>
							Regras de pagamento
						</div>
						<div
							className="menuList"
							onClick={() => {
								window.open(
									'https://www.diariomunicipal.com.br/femurn/pesquisar?busca_avancada%5Bpage%5D=&busca_avanca[…]U3HAAeqEfKALzNorl32SxwmKjZnlQLIhqOGZ4mwqCi8vyBS11rRQsJg'
								);
							}}
						>
							Consulta de licença
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
